import { tw } from "@careinfo/tailwind";
import APIS from "../../../../constant/Endpoint";
import ComboboxInput from "../../../Reusable/ComboboxInput";
import FileUpload from "../../../Reusable/FileUpload";
import NpDatePicker from "../../../Reusable/NepaliDatePicker";
import NumberField from "../../../Reusable/NumberField";
import TextAreaField from "../../../Reusable/TextAreaField";
import TextField from "../../../Reusable/TextField";
import FormDatePicker from "../../../Reusable/DateField";
import ACCOUNTS from "../../../../constant/Accounts";

const BankForm = (props: any) => {
  const {
    control,
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    watch,
    isDraft = true,
    isEdit,
    setOpenAccountPopup,
    setPartypopup,
  } = props;

  return (
    <>
      <div className={tw`grid grid-cols-3  gap-x-4 px-4`}>
        {isEdit ? (  
        <TextField
          label="Voucher Number"
          control={control}
          name={"seq_no"}
          placeholder="Enter Voucher Number"
          disabled={true}
        />
        ) : (
           <TextField
          label="Voucher Number"
          control={control}
          name={"number_series"}
          placeholder="Enter Voucher Number"
          disabled={true}
        />
        )}

        <NpDatePicker
          label="Miti"
          name="voucher_date"
          disabled={!isDraft}
          disableFuture={true}
          value={watch("voucher_date")}
          setValue={setValue}
          error={errors?.voucher_date}
        />

        <FormDatePicker
          label="Date"
          name="voucher_date"
          disabled={!isDraft}
          control={control}
        />
      </div>
      <div className={tw` grid grid-cols-2 gap-x-4 px-4`}>
        <div
          className={tw`w-full flex items-start justify-center mt-2 space-x-1`}
        >
          <ComboboxInput
            url={APIS.COA}
            queryKey={"bank-account"}
            register={register("account")}
            errors={errors?.account}
            name={"account"}
            label={"Bank Account"}
            disabled={!isDraft}
            setValue={setValue}
            props={{
              parent: ACCOUNTS.BANK_ID,
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7  bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setOpenAccountPopup((prev) => !prev)}
          >
            +
          </button>
        </div>

        <NumberField
          value={getValues("amount")}
          register={register("amount")}
          errors={errors?.amount}
          label={"Amount"}
          setValue={setValue}
          disabled={!isDraft}
          delimiter=","
          clearErrors={clearErrors}
        />
        <div
          className={tw`w-full flex items-start justify-center mt-2 space-x-1`}
        >
          <ComboboxInput
            url={APIS.COA}
            queryKey={"account"}
            register={register("party_account")}
            errors={errors?.party_account}
            name={"party_account"}
            label={"Ledger Account"}
            setValue={setValue}
            props={{
              is_group: false,
              children__isnull: true,
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
            disabled={!isDraft}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7  bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setPartypopup((prev) => !prev)}
          >
            +
          </button>
        </div>
        <div className={tw`mt-2`}>
          <TextField
            label="Reference Number"
            control={control}
            name={"reference_number"}
            disabled={!isDraft}
          />
        </div>
        <div className={tw`mt-2`}>
          <NpDatePicker
            label="Reference Date"
            name="reference_date"
            disabled={!isDraft}
            value={watch("reference_date")}
            setValue={setValue}
            disableFuture={true}
            error={errors?.reference_date}
          />
        </div>
        <div></div>
        <FileUpload
          label="Attachment"
          register={register("attachment")}
          watch={watch}
          errors={errors}
          setValue={setValue}
          disabled={!isDraft}
        />
        <TextAreaField
          label="Narration"
          control={control}
          disabled={!isDraft}
          name={"narration"}
          placeholder="Write notes here..."
        />

        {/* <TextField label="Attachment" control={control} name={"attachment"} /> */}
        {/* <TextField label="Narration" control={control} name={"narration"} /> */}
      </div>
    </>
  );
};

export default BankForm;
